
import { useTranslation } from 'react-i18next';
import {  useEffect, useState } from 'react';
import {getParamsData} from '../helpers/Utils';
import ReactModal  from 'react-modal';
import { useContext } from 'react';
import { c_or_f } from '../helpers/Utils';
import Btn from './Button';
import External from './Extrenal';
import {useConfig} from "../helpers/useConfig";
import reactStringReplace from 'react-string-replace';
const Now = (props) => {
    
    const [isExternalOpen, setExternalPopupIsOpen] = useState(false);
    const [isOpen, setPopupIsOpen] = useState(false);
    const [params_json, setParams] = useState(false);
    const [currentParam, setCurrentParam] = useState(false);
    const [currentTitle, setCurrentTitle] = useState(false);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const {configData, setConfig} = useConfig();
    const [url, setUrl] = useState(false);
    const { t } = useTranslation();
    const customStyles = {
        content: {
          width:(screenWidth > 800 ) ? '70%' :'100%',
          top: (screenWidth > 1200 ) ? '45%' :'45%',
          left: '30%',
           direction: (configData.lang == 1) ? 'rtl' : '',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-30%',
          transform: 'translate(-30%, -30%)',
        },
      };
     const ExternalStyles = {
        content: {
          width:(screenWidth > 800 ) ? '70%' :'100%',
          padding:'5px',
          top: (screenWidth > 500 ) ? '42%' :'42%',
          left: '30%',
           direction: (configData.lang == 1) ? 'rtl' : '',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-30%',
          transform: 'translate(-30%, -30%)',
        },
      };
      const toggleOpenExternal = (url) => {
        
        const url_cor = reactStringReplace(url, '&amp;', (match, i) => (
            '&'
          ));
        setUrl(url_cor.join(''));
        setExternalPopupIsOpen(!isExternalOpen);
      }
       useEffect(() => {
              const handleResize = () => {
                  setScreenWidth(window.innerWidth);
                  //alert(window.innerWidth);
      
              };
              
              handleResize();
              window.addEventListener('resize', handleResize);
      
              // Clean up the event listener when the component unmounts
              return () => {
                  window.removeEventListener('resize', handleResize);
              };
              
              }, []); // Empty dependency array means this effect runs once on mount
          
      

      const setIsOpen = ({isOpen}) => {
        
        setPopupIsOpen(isOpen);
      }
      function getParamTitle(activity, lang, prm_json){
        var j;
        if (prm_json.jws === undefined)
            return;
        for (j = 0; j< prm_json.jws.Parameters.length; j++){
            if (prm_json.jws.Parameters[j].name === activity){
                if (lang === 0) {
                    return prm_json.jws.Parameters[j].title0;
                }
                else {
                    return prm_json.jws.Parameters[j].title1;
                }
            }

        }
    }
    function getParamDesc(activity, lang, prm_json){
        var j;
        if (prm_json.jws === undefined)
            return;
        for (j = 0; j< prm_json.jws.Parameters.length; j++){
            if (prm_json.jws.Parameters[j].name === activity){
                if (lang === 0){ 
                     return prm_json.jws.Parameters[j].lang0;
                    }
                    else {
                     return prm_json.jws.Parameters[j].lang1;
                    }
            }

        }
       
     }
    const openDetails = (param) => {
        setCurrentTitle(getParamTitle(param, configData.lang, params_json));
        setCurrentParam(getParamDesc(param, configData.lang, params_json));
        //setPopupIsOpen(true);
        toggleOpenExternal(urls[param]);
    }

    function fliterParam(div){
        if (props.all === true){
            return '';
        }
        var params = configData.params;
        if (params.includes(div)){
            return '';
        }  else {
            return 'none';
        }
           
    }
  
    useEffect(() =>{
        const fetchJson = async () => {
        const params = await getParamsData();
        setParams(params);
       
      };
     fetchJson();
      const timer = setInterval(() => {
        fetchJson();
      }, 60000);
    }, [])
    const urls = new Map();
      urls['ValleyTemp'] = '?section=graph&profile=1&graph=tempMtempV.php&valley=1';
      urls['Temp'] = '?section=graph&amp;graph=tempLatestArchive.php&amp;profile=1';
      urls['RoadTemp'] = '?section=graph&amp;graph=temp3LatestArchive.php&amp;profile=2';
      urls['Humidity'] = '?section=graph&amp;graph=humLatestArchive.php&amp;profile=1';
      urls['Wind'] = '?section=graph&amp;graph=windLatestArchive.php&amp;profile=1';
      urls['DewPoint'] = '?section=graph&amp;graph=dewptLatestArchive.php&amp;profile=1';
      urls['RainChance'] = '?section=graph&amp;graph=rain.php&amp;profile=1';
      urls['Radiation'] = '?section=graph&graph=radLatestArchive.php&profile=1';
      urls['UV'] = '?section=graph&amp;graph=uvLatestArchive.php&amp;profile=2';
      urls['Dust'] = '?section=dust';
      urls['AirPressure'] = '?section=graph&amp;graph=baro.php&amp;profile=1';

    if (props.current === undefined)
        return "loading...";
    return (
          <div id="now" className={"blue_transp_box container " + (configData.lang == 1? 'rtl' : '')}>
            
            <div id="allparamsdiv" title="" className="row mx-auto ">
                
                <div id="temp" title="" className={`col-1 col-md-3 col-lg-1 mx-auto parambox white_box ${fliterParam('temp')}`} onClick={() => openDetails('Temp')}>
                <div className="imgbox"><img src="https://v2013.02ws.co.il/images/icons/temp.svg" width="30px" height="30px" alt={t("TEMP")} /></div>
                 
                <a href="#" className="highlow info">
                    {t("TEMP")} <br/>
                    {c_or_f(props.current.temp, configData.tempUnit)}°{(configData.tempUnit == 'F') ? 'F' : ''}
                    <span className="info">
                    {c_or_f(props.today.hightemp, configData.tempUnit)}°{(configData.tempUnit == 'F') ? 'F' : ''} ({props.today.hightemp_time})<br />
                    {c_or_f(props.today.lowtemp, configData.tempUnit)}°{(configData.tempUnit == 'F') ? 'F' : ''} ({props.today.lowtemp_time})
                    </span>
                </a>
                </div>
                <div id="temp2" title="" className={`col-1 col-md-3 col-lg-1 mx-auto parambox white_box ${fliterParam('temp2')}`}  onClick={() => openDetails('ValleyTemp')}>
                <div className="imgbox"><img src="https://v2013.02ws.co.il/images/icons/valleytemp.svg" width="30px" height="30px" alt={t("TEMP")} /></div>
                
                <a href="#" className="highlow info">
                    {t("TEMP")} {t("VALLEY")} <br/>
                    {c_or_f(props.current.temp2, configData.tempUnit)}°{(configData.tempUnit == 'F') ? 'F' : ''}
                    <span className="info">
                    {c_or_f(props.today.hightemp2, configData.tempUnit)}°{(configData.tempUnit == 'F') ? 'F' : ''} ({props.today.hightemp2_time})<br />
                    {c_or_f(props.today.lowtemp2, configData.tempUnit)}°{(configData.tempUnit == 'F') ? 'F' : ''} ({props.today.lowtemp2_time})
                    </span>
                </a>
                </div>
                <div id="temp3" title="" className={`col-1 col-md-3 col-lg-1 mx-auto parambox white_box ${fliterParam('temp3')}`}  onClick={() => openDetails('RoadTemp')}>
                <div className="imgbox"><img src="https://v2013.02ws.co.il/images/icons/roadtemp.svg" width="30px" height="30px" alt={t("TEMP")} /></div>
                 
                <a href="#" className="highlow info">
                    {t("TEMP")} {t("ROAD")} <br/>
                    {c_or_f(props.current.temp3, configData.tempUnit)}°{(configData.tempUnit == 'F') ? 'F' : ''}
                    <span className="info">
                    {c_or_f(props.today.hightemp3, configData.tempUnit)}°{(configData.tempUnit == 'F') ? 'F' : ''} ({props.today.hightemp3_time})<br />
                    {c_or_f(props.today.lowtemp3, configData.tempUnit)}°{(configData.tempUnit == 'F') ? 'F' : ''} ({props.today.lowtemp3_time})
                    </span>
                </a>
                </div>
                <div id="hum" title="" className={`col-1 col-md-3 col-lg-1 mx-auto parambox white_box ${fliterParam('hum')}`}  onClick={() => openDetails('Humidity')}>
                <div className="imgbox"><img src="https://v2013.02ws.co.il/images/icons/humidity.svg" width="30px" height="30px" alt={t("HUMIDITY")} /></div>
                
                <a href="#" className="highlow info">
                    {t("HUMIDITY")} <br/>
                    {props.current.hum}%
                    <span className="info">
                    {props.today.highhum}% ({props.today.highhum_time})<br />
                    {props.today.lowhum}% ({props.today.lowhum_time})
                    </span>
                </a>
                </div>
                <div id="windspd" title="" className={`col-1 col-md-3 col-lg-1 mx-auto parambox white_box ${fliterParam('windspd')}`}  onClick={() => openDetails('Wind')}>
                <div className="imgbox"><img src="https://v2013.02ws.co.il/images/icons/wind.svg" width="30px" height="30px" alt={t("WIND")} /></div>
                
                <a href="#" className="highlow info">
                    {t("WIND")} <br/> {props.current.windspd}{t('WIND_UNIT')} {props.current.winddir}
                    <span className="info">
                    {props.today.highwind}{t('WIND_UNIT')}  ({props.today.highwind_time})<br />
                    </span>
                </a>
                </div>
                <div id="dew" title="" className={`col-1 col-md-3 col-lg-1 mx-auto parambox white_box ${fliterParam('dew')}`}  onClick={() => openDetails('DewPoint')}>
                <div className="imgbox"><img src="https://v2013.02ws.co.il/images/icons/dew.svg" width="30px" height="30px" alt={t("DEW")} /></div>
                
                <a href="#" className="highlow info">
                    {t("DEW")} <br/> 
                    {c_or_f(props.current.dew, configData.tempUnit)}°{(configData.tempUnit == 'F') ? 'F' : ''}
                    <span className="info">
                    {c_or_f(props.today.highdew, configData.tempUnit)}°{(configData.tempUnit == 'F') ? 'F' : ''} ({props.today.highdew_time})<br />
                    {c_or_f(props.today.lowdew, configData.tempUnit)}°{(configData.tempUnit == 'F') ? 'F' : ''} ({props.today.lowdew_time})
                    </span>
                </a>
                </div>
                <div id="rain"  title="" className={`col-1 col-md-3 col-lg-1 mx-auto parambox white_box ${fliterParam('rain')}`}  onClick={() => openDetails('RainChance')}>
                <div className="imgbox"><img src="https://v2013.02ws.co.il/images/icons/rain.svg" width="30px" height="30px" alt={t("RAIN")} /></div>
                {t("RAIN")} <br/> {props.seasonTillNow.rain}{t('RAIN_UNIT')}    
                </div>
                <div id="rad" title="" className={`col-1 col-md-3 col-lg-1 mx-auto parambox white_box ${fliterParam('rad')}`}  onClick={() => openDetails('Radiation')}>
                <div className="imgbox"><img src="https://v2013.02ws.co.il/images/icons/radiation.svg" width="30px" height="30px" alt={t("RADIATION")} /></div>
                
                <a href="#" className="highlow info">
                    {t("RADIATION")}  <br/> {props.current.solarradiation}W/m2  <br/>
                    {props.today.sunshinehours}   {t("SUNSHINEHOURS")} 
                    <span className="info">
                    {props.today.highradiation} ({props.today.highradiation_time})<br />
                    </span>
                </a>
                </div>
                <div id="uv" title="" className={`col-1 col-md-3 col-lg-1 mx-auto parambox white_box ${fliterParam('uv')}`}  onClick={() => openDetails('UV')}>
                <div className="imgbox"><img src="https://v2013.02ws.co.il/images/icons/UV.svg" width="30px" height="30px" alt={t("UV")} /></div>
               
                <a href="#" className="highlow info">
                     {t("UV")} <br/>
                    {props.current.uv}
                    <span className="info">
                    {props.today.highuv} ({props.today.highuv_time})
                    </span>
                </a>
                </div>
                <div id="pm10" title="" className={`col-1 col-md-3 col-lg-1 mx-auto parambox white_box ${fliterParam('pm10')}`}  onClick={() => openDetails('Dust')}>
                <div className="imgbox"><img src="https://v2013.02ws.co.il/images/icons/dust.svg" width="30px" height="30px" alt={t("DUSTPM10")} /></div>
                {t("DUSTPM10")}<br/> {props.current.pm10} {t('DUST_UNIT')}<br/>
                {t("DUSTPM25")}<br/> {props.current.pm25} {t('DUST_UNIT')}
                </div>
                <div id="pressure" title="" className={`col-3 col-md-3 col-lg-1 mx-auto parambox white_box ${fliterParam('pressure')}`}  onClick={() => openDetails('AirPressure')}>
                <div className="imgbox"><img src="https://v2013.02ws.co.il/images/icons/pressure.svg" width="30px" height="30px" alt={t("BAR")} /></div>
                {t("BAR")} {props.current.pressure} {t('BAR_UNIT')}
                </div>
                
            </div>
            <div className="" id="itfeels">
     
            </div>
            <div  id="windy">   

            </div>
            <div className="rainpercent">

            </div>
            
         <ReactModal
        
         isOpen={isExternalOpen}
         contentLabel="Example Modal"
         style={ExternalStyles}
         onRequestClose={() => toggleOpenExternal(false)}
 
       >
          <Btn btnOnClick={() => toggleOpenExternal(false)} btnTitleText={""}  img={"X"} cssClasses="float-start">
                 
         </Btn>
         <div className="sidepopup">
          <External src={`https://v2013.02ws.co.il/small/${url}`} width={(screenWidth > 800 ) ? '100%' :'100%'} height="95%" className={props.cssClasses}/>                                   
         </div>
       </ReactModal>
       <ReactModal
            isOpen={isOpen}
            contentLabel="Example Modal"
            style={customStyles}
            onRequestClose={() => setIsOpen(false)}

        >
          <Btn btnOnClick={() => setIsOpen(false)} btnTitleText={""}  img={"X"} cssClasses="float-start">
                 
         </Btn>
            <h3>{currentTitle}</h3>
             <div dangerouslySetInnerHTML={{__html: currentParam}}></div>
        </ReactModal>
        </div>
        
    );
}

export default Now; 